module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//pet-effect_base_2.png?v=ffe14d9e";